import uid from 'uuid/v4';

import './style.scss';

const DotsLoader = () => {
	const createDots = () => {
		const dotsNumber = 3;
		const dots = [];

		for (let i = 0; i < dotsNumber; i += 1) {
			dots.push(<div key={uid()} className="dot" />);
		}

		return dots;
	};

	return (
		<div className="dots-loader-component">
			{ createDots() }
			<span className="placeholder-text">Loading</span>
		</div>
	);
};

export default DotsLoader;
